import React from 'react';

function Intro() {
  return (
    <section className="intro-crev section-padding pt-0" style={{ marginTop: '100px' }}>
      <div className="container">
        <div className="sec-head">
          <div className="row" style={{ marginLeft: '-0px' }}>
            <div className="col-lg-7">
              <h2 className="stroke">It can get complicated</h2>
            </div>
            <div className="col-lg-12" style={{ marginTop: '80px', textAlign: 'right' }}>
              <h2>So we simplified it</h2>
            </div>
            <div className="col-lg-7" style={{ marginTop: '80px' }}>
              <h2 className="stroke">Your Brand Blueprint</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro; 